<template>
    <div id="MapSearch">
        <div class="map-head">
            <van-search v-model="value" placeholder="请输入xx路xx号xx弄搜索" @input="change" />
        </div>
        <div class="map-content">
            <van-list>
                <van-cell class="item" v-for="(item,index) in list" :key="index"  @click="clickItem(item)">
                    <div class="name"><strong>{{item.name}}</strong></div>
                    <div class="city">{{item.city}},{{item.adName}}</div>
                    <div class="address">{{item.address}}</div>
                </van-cell>
            </van-list>
        </div>
        <div class="footer">
            <div class="button-back" @click="back()">返回</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Search,List,Cell } from 'vant';
    import 'vant/lib/search/style';
    import 'vant/lib/list/style';
    import 'vant/lib/cell/style';

    Vue.use(Search).use(List).use(Cell);
    import axios from "axios";
    export default {
        name: "MapSearch",
        props:{
            callbackFun:Function,
            city:String
        },
        data(){
            return{
                list:[],
                value:"",
            }
        },
        watch:{
            value:function (a,b) {
                if(a.length<3){
                    this.list.length=0;
                }
            }
        },

        methods:{
            http:function(){
                let URL = "https://restapi.amap.com/v3/place/text?key=083e1f1ae47870abdd45da70f08a06f7&city=" +this.city+
                    "&keywords="+this.value;
                axios.get(URL).then(response=>{
                    if(response.data.pois){
                        let _arr = [];
                        response.data.pois.forEach(item=>{
                            let obj = {
                                name:item.name,
                                city:item.cityname,
                                adName:item.adname,
                                address:item.address,
                                gdLat: item.location.split(',')[1],
                                gdLng: item.location.split(',')[0],
                            };
                            if(obj.adName.length>0){
                                _arr.push(obj)
                            }
                        });
                        this.list = _arr;
                    }
                }).catch(error => {
                });
            },
            /**
             * 文本框change
             */
            change:function () {
                if(this.value&&this.value.length>=2){
                    this.http();
                }

            },
            /**
             * 点击单个
             * @param item
             */
            clickItem:function (item) {
                if(this.callbackFun){
                    this.callbackFun(item);
                }

            },
            back(){
                this.clickItem(null);
            }
        },


    }
</script>

<style scoped lang="scss">
#MapSearch {
    .map-head {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 50px;
        border-bottom: 1px solid #dddddd;
    }
    .map-content {
        position: absolute;
        top: 50px;
        right: 0;
        overflow: auto;
        bottom: 50px;
        left: 0;
        .item {
            .name {
                font-size: 1rem;
            }
            .city {
                font-size: 0.8rem;
                line-height: normal;
            }
            .address {
                font-size: 0.8rem;
                line-height: normal;
            }
        }
    }
    .footer{
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        padding: 10px;
        .button-back{
            text-align: center;
            padding: 10px;
            border-radius: 50px;
            background: #0DC161;
            color: #FFFFFF;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/takeoutDialog/mapsearch.vue